export default function getAttachments(attachmentsFileNames, docType) {
  if (docType === "BILLING") {
    if (attachmentsFileNames && attachmentsFileNames.length > 0) {
      return '<i class="icon icon-attachment"></i>';
    } else {
      return "";
    }
  }
  return "";
}
